import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { useAuth } from "./authcontext";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const { loggedIn, user } = useAuth();

  const [warenkorb, setWarenkorb] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistItemCount, setWishlistItemCount] = useState(0);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [wishlistTotalAmount, setWishlistTotalAmount] = useState(0); // (unused right now, ok)
  const [cartTotalAmount, setCartTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const sqlID = "1001070";
  const sqlIDwl = "1002080";

  // Prevent overlapping cart fetches
  const cartFetchInFlightRef = useRef(false);

  const mapWarenkorbData = (data) => {
    if (!data?.records) return [];
    return data.records.map((wk) => ({
      kopf_id: wk.kopf_id,
      knr: wk.knr,
      wk_id: wk.wk_id,
      Bezeichnung: wk.Bezeichnung,
      datum: wk.datum,
      preis: wk.preis, // der übermittelte Preis ist inkorrekt! Mai 2026
      preisNX: wk.preisNX,
      titel: wk.titel,
      menge: wk.menge,
      bestellnummer: wk.bestellnummer,
      vormerker: wk.vormerker,
      bestellzeichen: wk.bestellzeichen,
      rabatt: wk.rabatt,
      meldenummer_meldetext: wk.meldenummer_meldetext,
      meldenummer_umbreit: wk.meldenummer_umbreit,
    }));
  };

  const mapWishlistData = (data) => {
    if (!data?.records) return [];
    return data.records.map((mz) => ({
      kopf_id: mz.kopf_id,
      knr: mz.knr,
      mz_id: mz.mz_id,
      m_id: mz.m_id,
      Bezeichnung: mz.Bezeichnung,
      datum: mz.datum,
      preis: mz.preis, 
      titel: mz.titel,
      menge: mz.menge,
      bestellnummer: mz.bestellnummer,
      isbn: mz.isbn,
      bestellzeichen: mz.bestellzeichen,
      rabatt: mz.rabatt,
      meldenummer_meldetext: mz.meldenummer_meldetext,
      meldenummer_umbreit: mz.meldenummer_umbreit,
    }));
  };

  const recalcCartTotals = (items) => {
    const totalQuantity = items.reduce((sum, item) => sum + (Number(item.menge) || 0), 0);
    setCartItemCount(totalQuantity);

  
    /*const totalAmount = items.reduce(
      (sum, item) => sum + (Number(item.preis) || 0) * (Number(item.menge) || 0),
      0
    );
    setCartTotalAmount(totalAmount);*/
    


  };

  const fetchWarenkorb = async () => {
    // Only customers (Typ K) should fetch cart
    if ( !loggedIn || !user?.session_id || !user?.aml || user?.typ !== "K") {
      return;
    }
  
    if (cartFetchInFlightRef.current) return;
    cartFetchInFlightRef.current = true;
  
    setLoading(true);
  
    try {
      const apiUrl = `/api-wk-anzeige/${sqlID}/${user.aml}/${user.session_id}/`;
      console.log("🔄 Fetching warenkorb from:", apiUrl);
  
      const response = await fetch(apiUrl);
  
      if (!response.ok) {
        throw new Error("Failed to fetch cart");
      }
  
      const arrayBuffer = await response.arrayBuffer();
      const decodedText = new TextDecoder("windows-1252").decode(arrayBuffer);
  
      if (decodedText.includes("session_not_found")) {
        console.warn("⚠️ Session not found (cart). Clearing cart.");
  
        setWarenkorb([]);
        setCartItemCount(0);
        setCartTotalAmount(0);
  
        return;
      }
  
      const data = JSON.parse(decodedText);
      const warenkorbMapped = mapWarenkorbData(data);
  
      setWarenkorb(warenkorbMapped);
  
      recalcCartTotals(warenkorbMapped);
  
    } catch (error) {
      console.error("❌ Error fetching cart:", error);
    } finally {
      setLoading(false);
      cartFetchInFlightRef.current = false;
    }
  };

/*
  const fetchWarenkorb = async () => {
    if (!loggedIn || !user?.session_id || !user?.aml) {
      
      return;
    }

    if (cartFetchInFlightRef.current) return;
    cartFetchInFlightRef.current = true;

    setLoading(true);
    try {
      const apiUrl = `/wk-anzeige/${sqlID}/${user.aml}/${user.session_id}/`;
      console.log("🔄 Fetching warenkorb from:", apiUrl);

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error("Failed to fetch cart");

      // encoding in React wg IIS:
      const arrayBuffer = await response.arrayBuffer();
      const decodedText = new TextDecoder("windows-1252").decode(arrayBuffer);

      // If response = non-json
      if (decodedText.includes("session_not_found")) {
        console.warn("⚠️ Session not found (cart). Clearing cart.");
        setWarenkorb([]);
        setCartItemCount(0);
        setCartTotalAmount(0);
        return;
      }

      const data = JSON.parse(decodedText);
      const warenkorbMapped = mapWarenkorbData(data);

      setWarenkorb(warenkorbMapped);
      recalcCartTotals(warenkorbMapped);
    } catch (error) {
      console.error("❌ Error fetching cart:", error);
    } finally {
      setLoading(false);
      cartFetchInFlightRef.current = false;
    }
  };
*/

  const updateCartItemLocal = (wk_id, field, newValue) => {
    setWarenkorb((prev) => {
      const next = prev.map((item) =>
        item.wk_id === wk_id ? { ...item, [field]: newValue } : item
      );
      
      recalcCartTotals(next);
      return next;
    });
  };

  // save + re-sync
  const updateCartItem = async (wk_id, field, newValue, extraParams = {}) => {
    if (!user?.session_id || !user?.aml) return;
  
    
    updateCartItemLocal(wk_id, field, newValue);
  
    const formData = new URLSearchParams();
  
   
    formData.append("session_id", user.session_id);
    formData.append("pg_id", user.pgid);
    formData.append("aml", user.aml);
    formData.append("caller", user.aml);
  
    formData.append("table", "warenkorb_pos");
    formData.append("id_field", "wk_id");
  
   
    formData.append("field", "wk_id");
    formData.append("wk_id", wk_id);
    formData.append("value", wk_id);
  
    
    if (field === "menge") formData.append("menge", newValue);
    if (field === "bestellzeichen") formData.append("bestellzeichen", newValue);
  
    
    Object.entries(extraParams).forEach(([k, v]) => {
      if (v !== undefined && v !== null) formData.append(k, String(v));
    });
  
    try {
      const res = await fetch("/api-wk/editjson2", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
  
      const text = await res.text();
  
  
      if (!text.includes("success: true")) {
        console.warn("Backend didn’t confirm update:", text);
        await fetchWarenkorb();
        return text;
      }
  
      
      await fetchWarenkorb();
      return text;
    } catch (err) {
      console.error("Error updating cart item:", err);
      await fetchWarenkorb(); 
      throw err;
    }
  };


  const saveCartChange = async ({ wk_id, field, newValue, extraParams = {} }) => {
    return updateCartItem(wk_id, field, newValue, extraParams);
  };

  //  Wishlist fetch mit encoding
  const fetchWishlist = async () => {
    if (!loggedIn || !user?.session_id || !user?.aml || user?.typ !== "K") return;

    setLoading(true);
    try {
      const apiUrl = `/api-mz-anzeige/${sqlIDwl}/${user.pgid}/${user.aml}/${user.session_id}/`;
      console.log("Fetching wishlist from:", apiUrl);

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error("Failed to fetch wishlist");

      const arrayBuffer = await response.arrayBuffer();
      const decodedText = new TextDecoder("windows-1252").decode(arrayBuffer);
      const data = JSON.parse(decodedText);

      const wishlistMapped = mapWishlistData(data);
      setWishlist(wishlistMapped);
      setWishlistItemCount(wishlistMapped.length);
    } catch (error) {
      console.error(" Error fetching wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteWishlistItem = async (m_id) => {
    const session_id = user?.session_id;
    const caller = user?.aml;
    const pg_id = user?.pgid;

    const formData = new URLSearchParams();
    formData.append("caller", caller);
    formData.append("m_id", m_id);
    formData.append("value", m_id);
    formData.append("table", "merkzettel");
    formData.append("field", "m_id");
    formData.append("session_id", session_id);
    formData.append("pg_id", pg_id);

    try {
      await fetch("/api-deleteajax", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
    } catch (err) {
      console.error("Network error:", err);
    }

    //alert("Artikel wurde(n) von der Merkliste gelöscht");
    await fetchWishlist();
  };

  //Refetch on session change 
  useEffect(() => {
    if (user?.session_id && user?.aml) {
      fetchWarenkorb();
    } else {
      setWarenkorb([]);
      setCartItemCount(0);
      setCartTotalAmount(0);
    }

  }, [user?.session_id, user?.aml]);

  useEffect(() => {
    if (user?.session_id && user?.aml) {
      fetchWishlist();
    } else {
      setWishlist([]);
      setWishlistItemCount(0);
    }
   
  }, [user?.session_id, user?.aml]);

  return (
    <CartContext.Provider
      value={{
        warenkorb,
        wishlist,
        cartItemCount,
        wishlistItemCount,
        cartTotalAmount,
        loading,

        // wk
        fetchWarenkorb,
        updateCartItem,
        saveCartChange,

        // mz
        fetchWishlist,
        deleteWishlistItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
